<div class="body">

    <div class="main-pesquisar">

        <mat-toolbar class="mat-elevation-z2 noselect toolbar-titulo">
            <div class="loading-shade" id="carregamento" style="visibility: hidden;">
                <mat-spinner></mat-spinner>
            </div>

            <div class="div-botao-voltar" (click)="goToHome()">
                <button mat-button class="botao-voltar">
                    <p class="p-botao-voltar">
                        <mat-icon style="padding: 5%;"> navigate_before </mat-icon>
                        Voltar
                    </p>
                </button>
            </div>

            <div class="div-pesquisar">
                <p class="p-pesquisar">
                    Pesquisar
                </p>
            </div>

            <span class="barra-topo"></span>

        </mat-toolbar>

        <div class="div-body">

            <div class="content" *ngIf="!isLoadingResults">

                <form [formGroup]="form">

                    <div class="grid grid--auto-fill">

                        <mat-form-field>
                            <mat-label>Nome do Aluno</mat-label>
                            <input formControlName="nomedoCliente" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Data do Atendimento</mat-label>
                            <input formControlName="datadoAtendimento" matInput [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker touchUi #picker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Canal de Atendimento</mat-label>
                            <mat-select formControlName="canaldeAtendimento">
                                <mat-option [value]="1"> Telefone </mat-option>
                                <mat-option [value]="2"> Balcão </mat-option>
                                <mat-option [value]="3"> Facebook </mat-option>
                                <mat-option [value]="4"> WhatsApp </mat-option>
                                <mat-option [value]="5"> Instagram </mat-option>
                                <mat-option [value]="6"> E-mail </mat-option>
                                <mat-option [value]="7"> Formulário Google </mat-option>
                                <mat-option [value]="8"> Dashboard Site </mat-option>
                                <mat-option [value]="9"> Formulário Site </mat-option>
                                <mat-option [value]="10"> Outros </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Celular</mat-label>
                            <input formControlName="celular" id="idCelular" [mask]="maskCelular" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Telefone Fixo</mat-label>
                            <input formControlName="telefoneFixo" [mask]="maskTelefoneFixoPrincipal" matInput>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Status do Aluno</mat-label>
                            <mat-select formControlName="statusdoAtendimento">
                                <mat-option [value]="1"> Não Matrículado </mat-option>
                                <mat-option [value]="5"> Já Matrículado em Nossa Escola </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Pesquisar: Data Inicial</mat-label>
                            <input formControlName="pesquisarDataInicial" matInput [matDatepicker]="picker1">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker touchUi #picker1></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Pesquisar: Data Final</mat-label>
                            <input formControlName="pesquisarDataFinal" matInput [matDatepicker]="picker2">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker touchUi #picker2></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Nome do Atendente</mat-label>
                            <mat-select formControlName="idAtendente">
                                <mat-option *ngFor="let usuario of usuariosUnidade" [value]="usuario.id">
                                    {{ usuario.userName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>

                    <div class="div-botoes">
                        <button mat-raised-button class="b-resetar-campos" type="reset" value="Reset">
                            <p class="p-resetar-campos">
                                Resetar Campos
                            </p>
                        </button>

                        <button mat-raised-button class="b-filtrar" (click)="goToResultados()">
                            <p class="p-filtrar">
                                Filtrar
                                <mat-icon style="padding: 5%;">navigate_next</mat-icon>
                            </p>
                        </button>
                    </div>

                </form>

            </div>

        </div>

        <div class="div-rodape">

            <div class="div-barra-navegacao">

                <button class="b-home">
                    <mat-icon class="mat-icon-button" (click)="goToHome()"> home </mat-icon>
                </button>

                <button class="b-novo-atendimento">
                    <mat-icon class="mat-icon-button" (click)="goToNovoAtendimento()"> add </mat-icon>
                </button>

                <button class="b-pesquisar">
                    <mat-icon class="mat-icon-button" (click)="goToPesquisar()"> search </mat-icon>
                </button>

                <button class="b-agendados">
                    <mat-icon class="mat-icon-button" (click)="goToAgendados()"> calendar_today </mat-icon>
                </button>
            </div>

        </div>

    </div>

</div>